/**
 * https://github.com/kentcdodds/kentcdodds.com/blob/main/config/website.js
 */
module.exports = {
  siteTitle: "Лизинг оборудования для партнеров", // Navigation and Site Title
  siteTitleShort: "Arenza", // short_name for manifest
  siteUrl: process.env.GATSBY_ROOT_URL || "https://arenza.ru", // Domain of your site. No trailing slash!
  lang: "ru", // Language Tag on <html> element
  pathPrefix: "/",
  siteLogo: "images/logo.png", // Used for SEO and manifest, path to your image you placed in the 'static' folder
  siteDescription:
    "Получите оборудование или технику в лизинг по специальным условиям - скидка до 30%",
  keywords: [],
  author: "Sergey Reutskiy", // Author for schemaORGJSONLD
  organization: 'ООО "АРЕНЗА-ПРО"',

  // Manifest and Progress color
  themeColor: "#FE5200",
  backgroundColor: "#232d3e",

  // Social component
  //   twitter: "",
  //   twitterHandle: "",
  //   github: "",
  //   linkedin: "",
  youtube: "https://www.youtube.com/channel/UCgpGldemItlUVOcE_uvltVA",
  //   rss: "",
};
